module.exports = __webpack_public_path__ + "img/sd-bb-a-1.bbc0692a.jpg";